<!--
 * @Author: FengXiao
 * @Date: 2020-07-03 21:15:46
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-12 14:56:29
-->
<template>
  <div class="home_banner-base">
    <div
      class="banner"
      v-for="(banner, index) in banners"
      :key="banner.id"
      :class="{ show: bannerActivatedIndex === index }"
      :ref="`banner_${index}`"
      @click="gotoDetail(banner)"
    >
      <template v-if="index === 0">
        <div class="speaker_info">
          <div class="speaker_avatar">
            <img :src="banner.speak.avatar" alt="" />
          </div>
          <div class="speaker_name">{{ banner.speak.name }}</div>
          <div class="speaker_intro">{{ banner.speak.intro }}</div>
          <div class="speaker_rank">
			  <span v-if="banner.speak.ranking !== 0">一席第{{ banner.speak.ranking }}位演讲者</span>
			  <span v-else>一席讲者</span>
			<!--  一席第 {{ banner.speak.ranking }} 位演讲者 -->
			</div>
          <div class="intro-wrap">
            <i class="iconfont icondouble-quotation-marks"></i>
            <div class="video_intro">
              {{ banner.titlelanguage }}
            </div>
          </div>
        </div>
        <div class="video_info" @mouseenter="activeBanner(index)">
          <div class="video_cover">
            <img class="video_cover-img" :src="banner.cover" :alt="banner.title" />
          </div>
          <div class="video_info-content">
            <i class="iconfont iconplayer"></i>
            <div class="video_title">{{ banner.title }}</div>
            <div class="video_time">{{ banner.time }}</div>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="video_info" @mouseenter="activeBanner(index)">
          <div class="video_cover">
            <img class="video_cover-img" :src="banner.cover" :alt="banner.title" />
          </div>
          <div class="video_info-content">
            <i class="iconfont iconplayer"></i>
            <div class="video_title">{{ banner.title }}</div>
            <div class="video_time">{{ banner.time }}</div>
          </div>
        </div>
        <div class="speaker_info">
          <div class="speaker_avatar">
            <img :src="banner.speak.avatar" alt="" />
          </div>
          <div class="speaker_name">{{ banner.speak.name }}</div>
          <div class="speaker_intro">{{ banner.speak.intro }}</div>
          <!-- <div class="speaker_rank">一席第 {{ banner.speak.ranking }} 位演讲者</div> -->
          <div class="speaker_rank">
			  <span v-if="banner.speak.ranking !== 0">一席第{{ banner.speak.ranking }}位演讲者</span>
			  <span v-else>一席讲者</span>
			</div>
		  <div class="intro-wrap">
            <i class="iconfont icondouble-quotation-marks"></i>
            <div class="video_intro">
              {{ banner.titlelanguage }}
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    datas: {
      type: Array,
      default: () => ({}),
    },
  },
  watch: {
    datas(arr) {
      this.banners = arr;
      if (this.banners.length) {
        this.$nextTick(() => {
          this.activeBanner();
        });
      }
    },
  },
  data() {
    return {
      bannerActivatedIndex: 1, // 当前激活的banner index
      banners: [],
    };
  },
  activated() {
    this.banners = this.datas;
	console.log(this.banners)
    if (this.banners.length) {
      this.$nextTick(() => {
        this.activeBanner();
      });
    }
  },
  methods: {
    activeBanner(index = this.bannerActivatedIndex || 1) {
      this.bannerActivatedIndex = index;
    },
    gotoDetail(data) {
      this.$router.push({
        path: '/speech/detail',
        query: {
          id: data.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.home_banner-base {
  width: 100%;
  background: url('../assets/imgs/banner-bg.png') no-repeat;
  background-position: center;
  background-size: cover;
  height: 520px;
  display: flex;
  justify-content: center;
  align-items: center;
  .banner {
    height: 430px;
    flex: 1;
    max-width: 50%;
    display: flex;
    align-items: center;
    position: relative;
    .speaker_info,
    .video_info {
      height: 100%;
      overflow: hidden;
      cursor: pointer;
    }
    .speaker_info {
      width: 40%;
      color: $C1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      padding: 50px 50px 0;
      background-color: $A1;
      min-width: 200px;
      max-width: 300px;
      opacity: 0;
      transition: opacity 0.3s ease-out;
      line-height: 22px;
      .speaker_avatar {
        width: 50px;
        height: 50px;
        min-height: 50px;
        border: 1px solid #fff;
        border-radius: 50%;
        margin-bottom: 10px;
        overflow: hidden;
        img {
          vertical-align: bottom;
          object-fit: cover;
          width: 100%;
          height: 100%;
          max-width: 100%;
        }
      }
      .speaker_name {
        font-family: HYXinRenWenSongW;
        font-size: 14px;
        line-height: 16px;
        margin-bottom: 5px;
      }
      .speaker_intro {
        font-size: 12px;
        line-height: 17px;
        margin-bottom: 5px;
      }
      .speaker_rank {
        font-size: 12px;
        line-height: 17px;
        color: #bdbdbd;
      }
      .intro-wrap {
        width: 100%;
        text-align: center;
        margin-top: 50px;
        .iconfont {
          display: inline-block;
          font-size: 14px;
          margin-bottom: 10px;
        }
        .video_intro {
          font-size: 12px;
          color: $C1;
          overflow: hidden;
          text-overflow: ellipsis;
          text-align: center;
          line-height: 17px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 4;
          -webkit-box-orient: vertical;
        }
      }
    }
    .video_info {
      width: 65%;
      transition: transform 0.3s ease, opacity 0.3s ease;
      transform: scale(0.8);
      max-width: 500px;
      opacity: 0.5;
      box-shadow: 0 0 10px 0 $A3;
      .video_cover {
        width: 100%;
        height: 100%;
        border-radius: 5px;
        overflow: hidden;
      }
      .video_info-content {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 5;
        color: $A2;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .iconfont {
          font-size: 60px;
          color: rgba(181, 181, 181, 0.8);
          background: rgba(0, 0, 0, 0.8);
          border-radius: 100%;
          width: 56px;
          height: 56px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        .video_title {
          font-size: 27px;
          margin-bottom: 7px;
          margin-top: 15px;
          font-family: HYXinRenWenSongW;
        }
        .video_time {
          font-size: 16px;
          font-family: 'Avenir-Book';
        }
        &::after {
          content: '';
          position: absolute;
          width: 100%;
          height: 100%;
          left: 0;
          top: 0;
          background-image: radial-gradient(50% 100%, rgba(0, 0, 0, 0.6) 46%, rgba(0, 0, 0, 0) 100%);
          border-radius: 5px;
          z-index: -1;
        }
      }
    }
    &:first-child {
      justify-content: flex-end;
      .video_info {
        margin-right: -5%;
      }
    }
    &:last-child {
      justify-content: flex-start;
      .video_info {
        margin-left: -5%;
      }
    }
  }
  .banner.show {
    .speaker_info {
      opacity: 1;
    }
    .video_info {
      transform: scale(1);
      z-index: 2;
      opacity: 1;
    }
  }
}
</style>
